import { computed, watch } from 'vue';
import { navigateTo, useNuxtApp } from 'nuxt/app';
import { useUserStore } from '~~/common/stores/user';
import { LT_ECOM } from '~~/common/config/LoginTypeConfig';

export function useRedirectOnLoginTypeChange () {
  watch(
    computed(() => {
      return useUserStore().loginType;
    }),
    (newValue, oldValue) => {
      const { $localePath } = useNuxtApp();
      // if user login type changed from ecom to other value, then redirect to home page
      if (newValue !== LT_ECOM && oldValue === LT_ECOM) {
        navigateTo($localePath('/'));
      }
    },
  );
}
